module.exports = __webpack_public_path__ + "img/signature.9656bcc4.png";